import { Box } from '@mui/material';
import { ERecordLength } from '../../data/Constants';
import { useState } from 'react';
import { RecordLengthPicker } from '../RecordLengthPicker';

import type { IRecordPerPage } from '../../../types';

/**
 * RecrodsPerPage is be set for Pdm landing page and Procos Page.
 * @param {IRecordPerPage} props is the callback actions
 * @returns JSX
 */

const RecordsPerPage = (props: IRecordPerPage) => {
  const [recordsPerPage, setRecordsPerPage] = useState(props?.value ?? ERecordLength.RL15);

  /**
   * This function set the selected record
   * @param e is the current elemnt for the selected value
   */

  const handleRecordsChange = (e) => {
    props.handleRecordsChange(e.target.value);
    setRecordsPerPage(e.target.value);
  };

  return (
    <Box className="recordsChange-conatiner">
      <RecordLengthPicker limit={recordsPerPage} handleRecordsChange={handleRecordsChange} />
    </Box>
  );
};

export default RecordsPerPage;
